export default __webpack_public_path__ + "static/media/introimage.becd1465.svg";